import { combineReducers } from 'redux';
import exhibitions from './exhibitionsReducer';
import artworks from './artworksReducer';
import awards from './awardsReducer';
import sketchADays from './sketchADaysReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';
import { routerReducer } from 'react-router-redux';

const rootReducer = combineReducers({
    exhibitions,
    artworks,
    awards,
    sketchADays,
    ajaxCallsInProgress,
    routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js